import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

export interface ConnectMember {
  connectUserId: string;
  clinicalUserId: string | null;
  name: string;
  email: string;
  roles: string[];
  isActive: boolean;
  isOwner: boolean;
}

export interface ConnectBilling {
  arrangement: 'shared_clinical' | 'own_card' | 'bureau' | 'none';
  billingDayOfMonth: number | null;
  card: { brand: string; last4: string; expMonth: number; expYear: number } | null;
}

export interface ConnectSettings {
  canManage: boolean;
  members: ConnectMember[];
  billing: ConnectBilling;
  connectOrigin: string;
  /** The signed-in user's Connect account, so the panel does not offer them changes to their own access. */
  you: string | null;
}

/** Settings > MedicAI Connect: who has access and who pays, held on Connect and changed there through clinical. */
@Injectable({ providedIn: 'root' })
export class ConnectSettingsService {
  constructor(private http: HttpClient) {}

  private get headers() {
    return { Authorization: `Bearer ${localStorage.getItem('token')}` };
  }

  load(groupId: string): Observable<ConnectSettings> {
    return this.http.get<{ data: ConnectSettings }>(`api/connect-settings/group/${groupId}`, { headers: this.headers })
      .pipe(map(res => res.data));
  }

  setMember(groupId: string, userId: string, role: string): Observable<any> {
    return this.http.put(`api/connect-settings/group/${groupId}/members/${userId}`, { role }, { headers: this.headers });
  }

  removeMember(groupId: string, userId: string): Observable<any> {
    return this.http.delete(`api/connect-settings/group/${groupId}/members/${userId}`, { headers: this.headers });
  }

  setBilling(groupId: string, billing: { shareSubscription: boolean; billingDayOfMonth?: number }): Observable<any> {
    return this.http.put(`api/connect-settings/group/${groupId}/billing`, billing, { headers: this.headers });
  }

  /** Sends the saved enable request again after a failed or stalled setup. */
  retrySetup(groupId: string): Observable<any> {
    return this.http.post(`api/subscription/connect-enable/${groupId}/retry`, {}, { headers: this.headers });
  }
}
